export default {
  // API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://glaiza-zac-spaced-rep-server.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token',
}
